'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = minifyCSSString;
function minifyCSSString(style) {
  return style.replace(/\s{2,}/g, '');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/minifyCSSString.js
// module id = 438
// module chunks = 0